export default __webpack_public_path__ + "static/media/detail-note3.ba0fee51.svg";